const getters = {
  token: (state) => state.user.token,
  avatar: (state) => state.user.avatar,
  name: (state) => state.user.name,
  userId: (state) => state.user.userId,
  paperType: (state) => state.user.paperType,
  testPaperId: (state) => state.user.testPaperId,
  judgeRightOrWrong: (state) => state.user.judgeRightOrWrong,
  backclass: (state) => state.read.backclass,
  searchText: (state) => state.read.searchText,
  redirectParams: (state) => state.routerHelp.redirectParams,
  myResourceNum: (state) => state.user.myGoodsNum + state.user.mySubjectNum + state.user.myBundleNum
}
export default getters
